import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import Swipeable from 'react-swipeable';
import CircularProgress from 'material-ui/CircularProgress';

import { changeState } from '../actions/index';
import { ASSET_PREFIX } from '../config/constants';

import arrowLeft from '../images/arrow-left.svg';
import arrowRight from '../images/arrow-right.svg';
import peds0 from '../images/peds-icons-2@3x.png';
import peds1 from '../images/peds-superhero@3x.png';
import peds2 from '../images/peds-graph-2@3x.png';
import peds3 from '../images/peds-clock@3x.png';
import pa0 from '../images/pa-icons-2@3x.png';
import pa1 from '../images/pa-superhero@3x.png';
import pa2 from '../images/pa-graph-2@3x.png';
import pa3 from '../images/pa-clock@3x.png';

import '../styles/Features.css';

class Features extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 0
    };

    this.onKeyDown = _.debounce(this.onKeyDown, 75, {
      leading: true,
      trailing: false
    }).bind(this);

    this.handleNavBackward = this.handleNavBackward.bind(this);
    this.handleNavForward = this.handleNavForward.bind(this);
    this.onKeyDown = _.debounce(this.onKeyDown, 50).bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  onKeyDown(e) {
    switch (e.code) {
      case 'ArrowLeft':
        this.handleNavBackward();
        break;
      case 'ArrowRight':
        this.handleNavForward();
        break;
      default:
    }
  }

  handleNavBackward() {
    const { tabIndex } = this.state;

    tabIndex > 0 ? this.setState({ tabIndex: tabIndex - 1 }) : null;
  }

  handleNavForward() {
    const { tabIndex } = this.state;
    const { changeState, features, params } = this.props;

    tabIndex < features.length - 1
      ? this.setState({ tabIndex: tabIndex + 1 })
      : changeState(params.firstRun ? 'firstRun' : 'init');
  }

  render() {
    const currentTab = this.props.features[this.state.tabIndex];
    const isMobile = window.innerWidth < 1000;
    const pedsIcons =
      this.props.features.length === 1 ? [peds3] : [peds0, peds1, peds2, peds3];
    const paIcons =
      this.props.features.length === 1 ? [pa3] : [pa0, pa1, pa2, pa3];
    return (
      <div className="feature">
        <div className="center-content-horizontal">
          {this.props.features.length ? (
            <Swipeable
              onSwipedRight={this.handleNavBackward}
              onSwipedLeft={this.handleNavForward}
            >
              <div className="feature-container">
                <img
                  alt="feature icon"
                  className="feature-icon"
                  src={
                    ASSET_PREFIX[this.props.product] === 'peds'
                      ? pedsIcons[this.state.tabIndex]
                      : ASSET_PREFIX[this.props.product] === 'pa'
                        ? paIcons[this.state.tabIndex]
                        : currentTab.iconUrl
                  }
                />
                <p className="feature-title">{currentTab.title}</p>
                <p className="feature-explanation">{currentTab.explanation}</p>
                <div className="feature-nav-container">
                  <div
                    className={`feature-nav ${
                      this.state.tabIndex > 0 ? '' : ' hide-feat-nav'
                    }`}
                    onClick={this.handleNavBackward}
                  >
                    <img alt="" className="nav-arrow" src={arrowLeft} />
                  </div>
                  <div className="center-content feature-center-row">
                    <img
                      alt="feature"
                      className={`feature-image${this.state.tabIndex}`}
                      src={
                        isMobile
                          ? currentTab.mobileImageUrl
                          : currentTab.imageUrl
                      }
                    />
                  </div>
                  <div className="feature-nav" onClick={this.handleNavForward}>
                    <img alt="" className="nav-arrow" src={arrowRight} />
                  </div>
                </div>
              </div>
            </Swipeable>
          ) : (
            <CircularProgress size={60} thickness={7} color="#95BF5E" />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    features: state.app.newFeatures,
    product: state.app.product
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ changeState }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Features);



// WEBPACK FOOTER //
// ./src/containers/Features.js